import React from "react";

import createReactClass from 'create-react-class';
import PropTypes from "prop-types";
import BaseMixin from './BaseMixin';
import StringCompareTerminalMixin from './StringCompareTerminalMixin';

import Select2 from "shared/react_components/Select2";

const CustomData = createReactClass({
  displayName: 'CustomData',
  mixins: [BaseMixin, StringCompareTerminalMixin],

  propTypes: {
    node: PropTypes.object.isRequired,
    selectUrls: PropTypes.object.isRequired,
    editable: PropTypes.bool
  },

  render: function() {
    return (
      <form className="form-inline custom-data-terminal">
        {this.renderTerminalName()}
        {this._renderCustomerDataParamName()}
        {this.renderRelOp()}
        {this.renderValue()}
      </form>
    );
  },

  selectChangeListener: function(data) {
    this.props.node.set({
      partner_name: data.partner_name,
      friendly_name: data.text
    });
  },

  _renderCustomerDataParamName: function() {
    // initialize the text if model is already set
    var initialValue = this.props.node.get('partner_name');
    if (initialValue) {
      this.props.node.set("partner_name_label", initialValue, { silent: true });
    }

    if (this.props.editable) {
      return (
        <Select2
          uniqueNameField ='partner_name'
          friendlyNameField='friendly_name'
          node={this.props.node}
          url={this.props.selectUrls.fieldsApiUrl}
          changeListener={this.selectChangeListener}
        />
      );
    } else {
      return this._renderReadonlyValue(initialValue);
    }
  }
});

export default CustomData;
